import React from 'react';

// Импортируем модульные стили
import styles from './SalePitchSection.module.css';

// Импортируем иконки для наглядности
import { ReactComponent as DomainIcon } from '../../assets/icons/domain.svg';
import { ReactComponent as TechIcon } from '../../assets/icons/tech.svg';
import { ReactComponent as SeoIcon } from '../../assets/icons/seo.svg';
import { ReactComponent as LeadIcon } from '../../assets/icons/lead.svg';

// Данные для карточек преимуществ сайта как актива
const assetFeatures = [
  {
    Icon: DomainIcon,
    title: 'Премиум-домен',
    description: 'Короткий, запоминающийся и релевантный домен BRU.kz (Бетонно-Растворный Узел) — идеален для лидера рынка.',
  },
  {
    Icon: TechIcon,
    title: 'Современные технологии',
    description: 'Сайт создан на React — это гарантирует высокую скорость, адаптивность и легкую масштабируемость в будущем.',
  },
  {
    Icon: SeoIcon,
    title: 'SEO-оптимизация',
    description: 'Проработанная структура, семантическая верстка и мета-теги для высоких позиций в поисковой выдаче Google и Яндекс.',
  },
  {
    Icon: LeadIcon,
    title: 'Готов к лидогенерации',
    description: 'Интегрирована "умная" форма сбора заявок и аналитика для отслеживания эффективности. Начинайте получать клиентов сразу!',
  },
];


const SalePitchSection = () => {
  return (
    <section id="sale-pitch" className={styles.salePitchSection}>
      <div className="container">
        <div className={styles.titleWrapper}>
          <h2 className={styles.sectionTitle}>Готовое решение для вашего бизнеса</h2>
          <p className={styles.sectionSubtitle}>
            BRU.kz — это не просто сайт, а готовый маркетинговый актив, созданный для привлечения клиентов в строительной отрасли.
          </p>
        </div>
        
        {/* Сетка с преимуществами сайта */}
        <div className={styles.featuresGrid}>
          {assetFeatures.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.iconWrapper}>
                <feature.Icon className={styles.icon}/>
              </div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
        
        {/* Призыв к действию для покупателя */}
        <div className={styles.ctaWrapper}>
          <p>Хотите, чтобы этот сайт работал на вас?</p>
          {/* ВАЖНО: Замените 'YOUR_TELEGRAM_USERNAME' на ваш реальный контакт */}
          <a href="https://t.me/YOUR_TELEGRAM_USERNAME" target="_blank" rel="noopener noreferrer" className={styles.ctaButton}>
            Связаться по поводу покупки
          </a>
        </div>
      </div>
    </section>
  );
};

export default SalePitchSection;